module.exports = __webpack_public_path__ + "img/9788901086101.0ab482fb.jpg";